import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { Textarea } from "@/components/ui/textarea";
import { trackNotesEntered } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionLabel from "./OptionLabel";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
export default function SpecialInstructions() {
  const $ = _c(15);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const specialInstructions = usePdpStore(_temp);
  const setSpecialInstructions = usePdpStore(_temp2);
  const lastTrackedValue = useRef(specialInstructions ?? "");
  const microcopyFields = useProductMicrocopy();
  if (productAdmin && !productAdmin.allowSpecialInstructions) {
    return null;
  }
  const controlIdBase = `special-instructions-${product.sku}`;
  const helpDialogId = `${controlIdBase}-help-dialog`;
  const label = microcopyFields?.specialInstructionsLabel ?? "Special Instructions";
  const helper = microcopyFields?.specialInstructionsHelper;
  let t0;
  if ($[0] !== controlIdBase || $[1] !== helpDialogId || $[2] !== helper || $[3] !== label) {
    t0 = <OptionLabel htmlFor={controlIdBase} label={label} helper={helper} helpDialogId={helpDialogId} optional={true} />;
    $[0] = controlIdBase;
    $[1] = helpDialogId;
    $[2] = helper;
    $[3] = label;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const t1 = specialInstructions ?? "";
  let t2;
  if ($[5] !== setSpecialInstructions) {
    t2 = e => setSpecialInstructions(e.target.value || undefined);
    $[5] = setSpecialInstructions;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      const trimmed = e_0.target.value.trim();
      if (trimmed && trimmed !== lastTrackedValue.current) {
        lastTrackedValue.current = trimmed;
        trackNotesEntered(trimmed);
      }
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== controlIdBase || $[9] !== t1 || $[10] !== t2) {
    t4 = <Textarea id={controlIdBase} value={t1} onChange={t2} onBlur={t3} placeholder="Anything else we should know?" className="min-h-0 resize-none text-sm" rows={1} />;
    $[8] = controlIdBase;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t0 || $[13] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t0}{t4}</div>;
    $[12] = t0;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp2(state_0) {
  return state_0.setSpecialInstructions;
}
function _temp(state) {
  return state.specialInstructions;
}